import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import ExternalStatusModalUI from './ExternalStatusModalUI.js'

class ExternalStatusModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      cpCsStatus: '',
      cpCsStatusError: null,
      //
      reuploadMessage: '',
      reuploadMessageError: null,
      //
      waivedMessage: '',
      waivedMessageError: null,
      //
      extendedDueDate: '',
      extendedDueDateError: null,
      //
      extendedDueDateReason: '',
      extendedDueDateReasonError: null,
    }
  }

  render() {
    const csStatusList = [
      { key: 'pending', value: 'Pending' },
      { key: 'to_be_reviewed', value: 'To Be Reviewed' },
      { key: 'complied', value: 'Complied' },
      { key: 'reviewed_and_requires_resubmission', value: 'Reviewed and Requires Resubmission' },
      { key: 'not_applicable', value: 'Not Applicable' },
      { key: 'not_complied', value: 'Not Complied' },
      { key: 'waived', value: 'Waived' },
      { key: 'due_date_extended', value: 'Due Date Extended' },
    ]

    const cpStatusList = [
      { key: 'pending', value: 'Pending' },
      { key: 'to_be_reviewed', value: 'To Be Reviewed' },
      { key: 'complied', value: 'Complied' },
      { key: 'reviewed_and_requires_resubmission', value: 'Reviewed and Requires Resubmission' },
      { key: 'not_applicable', value: 'Not Applicable' },
    ]

    const cpCsStatusList = this.props.compliance === 'cp' ? cpStatusList : csStatusList
    return (
      <ExternalStatusModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        cpCsStatusList={cpCsStatusList}
        cpCsStatus={this.state.cpCsStatus}
        onCpCsStatusChange={(event) => {
          this.setState({
            cpCsStatus: event.target.value,
            extendedDueDate: event.target.value === 'due_date_extended' ? this.state.extendedDueDate : '',
            extendedDueDateError: null,
            extendedDueDateReason: event.target.value === 'due_date_extended' ? this.state.extendedDueDateReason : '',
            extendedDueDateReasonError: null,
          })
        }}
        cpCsStatusError={this.state.cpCsStatusError}
        setCpCsStatusError={(error) => { this.setState({ cpCsStatusError: error }) }}
        //
        reuploadMessage={this.state.reuploadMessage}
        onReuploadMessageChange={(event) => { this.setState({ reuploadMessage: event.target.value }) }}
        reuploadMessageError={this.state.reuploadMessageError}
        setReuploadMessageError={(error) => { this.setState({ reuploadMessageError: error }) }}
        //
        waivedMessage={this.state.waivedMessage}
        onWaivedMessageChange={(event) => { this.setState({ waivedMessage: event.target.value }) }}
        waivedMessageError={this.state.waivedMessageError}
        setWaivedMessageError={(error) => { this.setState({ waivedMessageError: error }) }}
        //
        extendedDueDate={this.state.extendedDueDate}
        onExtendedDueDateChange={(isoDateString) => { this.setState({ extendedDueDate: isoDateString, extendedDueDateError: null }) }}
        extendedDueDateError={this.state.extendedDueDateError}
        setExtendedDueDateError={(error) => { this.setState({ extendedDueDateError: error }) }}
        //
        // Pass the new props to ExternalStatusModalUI in render():
        extendedDueDateReason={this.state.extendedDueDateReason}
        onExtendedDueDateReasonChange={(event) => {
          this.setState({ extendedDueDateReason: event.target.value, extendedDueDateReasonError: null })
        }}
        extendedDueDateReasonError={this.state.extendedDueDateReasonError}
        setExtendedDueDateReasonError={(error) => { this.setState({ extendedDueDateReasonError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    if (this.state.submitted) return

    // Client-side validation: extended due date required when due_date_extended
    if (this.state.cpCsStatus === 'due_date_extended' && !this.state.extendedDueDate) {
      this.setState({ extendedDueDateError: 'Please select an extended due date.' })
      return
    }
    if (this.state.cpCsStatus === 'reviewed_and_requires_resubmission' && !this.state.reuploadMessage) {
      this.setState({ reuploadMessageError: 'Please enter a resubmission reason.' })
      return
    }
    if (this.state.cpCsStatus === 'due_date_extended' && !this.state.extendedDueDateReason.trim()) {
      this.setState({ extendedDueDateReasonError: 'Please enter a reason for the extension.' })
      return
    }

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/compliances/${this.props.selectedFileCode}/externalStatus`,
      this.onSubmitCallback, {
      status: this.state.cpCsStatus,
      reuploadMessage: this.state.reuploadMessage,
      waivedMessage: this.state.waivedMessage,
      // Only populated for due_date_extended; backend ignores it for all other statuses
      extendedDueDate: this.state.cpCsStatus === 'due_date_extended' ? this.state.extendedDueDate : null,
      extendedDueDateReason: this.state.cpCsStatus === 'due_date_extended' ? this.state.extendedDueDateReason : null,
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 10)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(ExternalStatusModalSF)